export default __webpack_public_path__ + "static/media/G0210-TLoC.1711031940000.0603dd5f.jpg";